import { render, staticRenderFns } from "./SysMessage.vue?vue&type=template&id=947191e6&scoped=true&"
import script from "./SysMessage.vue?vue&type=script&lang=js&"
export * from "./SysMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947191e6",
  null
  
)

export default component.exports